import { IGameChatRoomViewModel } from '@/app-modules/config';

class ChatRoomConfiguration {
  constructor(public name: string, public frontEndName: string, public chatRooms: IGameChatRoomViewModel[]) {
    if (chatRooms && chatRooms.length === 1) {
      chatRooms[0].Name = name;
      chatRooms[0].FrontEndName = frontEndName;
    }
  }
}

export { ChatRoomConfiguration };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/config/models/chatroom-configuration.ts